import { Spoller } from "@plugins";

const mapSiteBlock = document.querySelectorAll(".js-map-site-block");

if (mapSiteBlock && mapSiteBlock.length) {
    window.addEventListener("load", () => {
        new Spoller(".js-map-site-block", {
            duration: 250,
            selectorToggleBtn: ".js-map-site-toggle-btn",
            selectorContent: ".js-map-site-block-content",
            makeToggleBtnActive: false,
        });
    });
}
